import { t } from "@/i18n/sk";

const styles = {
  in_stock: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  low_stock: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  preorder: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
  sold_out: "bg-rose-500/10 text-rose-300 border-rose-500/30",
};

export function StockBadge({ availability, className = "", testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-semibold ${styles[availability] || styles.in_stock} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {t.availability[availability] || availability}
    </span>
  );
}

export default StockBadge;
